export default function About() {
  return (
    <section id="about" className="py-24 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="mb-6">
              <span className="text-[#1A2332] text-sm font-medium">• Voice</span>
            </div>

            <div className="space-y-10">
              <div>
                <blockquote className="text-lg font-serif text-[#1A2332] leading-relaxed mb-6">
                  "帳簿のことは何もわからなくて、毎月どこかに頼むのも怖かったけど、領収書を渡すだけで全部やってもらえて本当に助かっています。"
                </blockquote>
                <div className="flex items-center gap-4">
                  <div>
                    <p className="font-bold text-[#1A2332]">T.M.様</p>
                    <p className="text-sm text-gray-500 mb-1">美容室オーナー</p>
                    <div className="flex items-center gap-2">
                      <div className="flex gap-1">
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-10">
                <blockquote className="text-lg font-serif text-[#1A2332] leading-relaxed mb-6">
                  "パソコンが本当に苦手で、クラウド会計も諦めてたんですが、一から丁寧に教えてもらって今は自分でも少し使えるようになりました。"
                </blockquote>
                <div className="flex items-center gap-4">
                  <div>
                    <p className="font-bold text-[#1A2332]">S.S.様</p>
                    <p className="text-sm text-gray-500 mb-1">ネイルサロンオーナー</p>
                    <div className="flex items-center gap-2">
                      <div className="flex gap-1">
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-10">
                <blockquote className="text-lg font-serif text-[#1A2332] leading-relaxed mb-6">
                  "経理もITも全然ダメで、確定申告の時期がくるたびにパニックでした。相談してからは気持ちが楽になって、施術に集中できています。"
                </blockquote>
                <div className="flex items-center gap-4">
                  <div>
                    <p className="font-bold text-[#1A2332]">Y.S.様</p>
                    <p className="text-sm text-gray-500 mb-1">エステサロンオーナー</p>
                    <div className="flex items-center gap-2">
                      <div className="flex gap-1">
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-start">
            <img
              src="https://public.readdy.ai/ai/img_res/15a9da523e165f5a5a66f15f70a00b18.jpg"
              alt="サロンオーナーの声"
              className="w-44 md:w-52 rounded-3xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
